import { render, staticRenderFns } from "./OrdersStatusScreen.vue?vue&type=template&id=5873717b"
import script from "./OrdersStatusScreen.vue?vue&type=script&lang=ts"
export * from "./OrdersStatusScreen.vue?vue&type=script&lang=ts"
import style0 from "./OrdersStatusScreen.vue?vue&type=style&index=0&id=5873717b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports